import React from 'react'
import Dropdown from './Dropdown'
import { dayFields, monthFields, yearFields } from './DropdownValues'

export default class BirthDate extends React.Component {

	render() {
		const { birthDay, birthMonth, birthYear, onSelectChange, property } = this.props
		const dayOptions = dayFields(birthMonth, birthYear)
		const monthOptions = monthFields()
		const yearOptions = yearFields()
		return (
			<div className='capps-input-container'>
				<div className='capps-dropdown'>
					<Dropdown
						name='birthDay'
						onSelectChange={onSelectChange}
						options={dayOptions}
						property={property}
						value={birthDay}
					/>
					<Dropdown
						name='birthMonth'
						onSelectChange={onSelectChange}
						options={monthOptions}
						property={property}
						value={birthMonth}
					/>
					<Dropdown
						name='birthYear'
						onSelectChange={onSelectChange}
						options={yearOptions}
						property={property}
						value={birthYear}
					/>
				</div>
			</div>
		)
	}

}



// WEBPACK FOOTER //
// ./src/Components/Display/BirthDate.js